import React, { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  SoilMoisture1,
  SoilMoisture2,
  Moisture1,
  Moisture2,
  AirTemperature,
  AirHumidity,
  SoilTemperature,
  AirPressure,
  LeafWetness,
  LightIntensity,
  WindSpeed,
  Rainfall,
  DeltaT,
  VPD,
} from "./sensors";
import { t } from "../../services/locale.service";
import { FylloHeader } from "react-library";
import { Routes } from "../../routes";
import { TBackEvent } from "../../types";
import Diseases from "./diseases";

const PlotChart = () => {
  const { sensor, plotId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const { state } = location;
  const { sensorName, isDisease, isPest } = state;

  const SensorGraph = SensorGraphMapping[sensor!];
  const headerTitle = sensorName + " " + t("Details");

  useEffect(() => {
    window.addEventListener("back-icon-press", handleBack);
    return () => {
      window.removeEventListener("back-icon-press", handleBack);
    };
  }, []);

  const handleBack = (e: Event) => {
    const event = e as TBackEvent;
    const eventKey = event.detail;
    if(eventKey === headerTitle) {
      navigate(Routes.plot.replace(":plotId", plotId!));
    }
  };

  return (
    <div className="m-0 p-0">
      <FylloHeader headerTitle={headerTitle} hasBackIcon />

      <div className="flex content-center items-center">
        {SensorGraph && (
          <SensorGraph />
        )}  

        { isDisease && (
          <Diseases />
        )}

        {
          isPest && <Diseases />
        }
      </div>
    </div>
  );
};

export default PlotChart;

/**
 * ================== TYPES ======================
 */
type TComponentMapping = Record<
  string,
  React.FC
>;


/**
 * ================== Sensor Component Mapping ======================
 */
const SensorGraphMapping: TComponentMapping = {
  soilMoisture1: SoilMoisture1,
  soilMoisture2: SoilMoisture2,
  moisture1: Moisture1,
  moisture2: Moisture2,
  airTemp: AirTemperature,
  airHumidity: AirHumidity,
  soilTemp: SoilTemperature,
  airPressure: AirPressure,
  leafWetness: LeafWetness,
  lightIntensity: LightIntensity,
  rainFall: Rainfall,
  windSpeed: WindSpeed,
  deltaT: DeltaT,
  vpd: VPD,
  VPD: VPD, // Handle uppercase VPD in URL
};